// A shared permission grants portal self-service, not admission to staff UI.
// Custom staff roles continue to use the existing permission-first policy.
export function isPortalWorkspaceDenied(role, roles, hasPermissionGate) {
  return ["patient", "guest"].includes(role)
    && hasPermissionGate
    && (!roles || !roles.includes(role));
}
